'use client'

import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import { CustomDataSaveButtons } from '@repo/custom-data-pages/CustomDataSaveButtons'
import { EditIcon } from '@repo/ui/EditIcon'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import MUIIconButton from '@mui/material/IconButton'
import MUIStack from '@mui/material/Stack'
import MUITooltip from '@mui/material/Tooltip'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const CustomDataPageHeading = ({
  title,
  id,
  toggleEditMode,
  onToggleOpen,
  isOpen,
  onSave,
  onCancel,
  pageIsInEditMode,
  valuesLoaded
}) => {
  const { allowedActions } = useMenuItemsStore()
  const allowEditCustomData = allowedActions.editCustomData?.allowed || false

  if (!title) return <MUIStack data-testid="CustomDataPageHeading" />

  return (
    <MUIStack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      data-testid="CustomDataPageHeading"
      sx={{ cursor: 'pointer', position: 'relative', pl: '34px' }}
    >
      <ChevronRightIcon
        onClick={onToggleOpen}
        sx={{
          transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
          color: '#3D517B8F',
          width: '34px',
          height: '34px',
          position: 'absolute',
          left: '0',
          top: 'calc(50% - 17px)'
        }}
      />
      <MUIStack direction="column" spacing={1} alignItems="flex-start" sx={{ flex: 1 }} onClick={onToggleOpen}>
        <MUITypography variant="h5" sx={{ fontSize: '1rem', cursor: 'pointer', userSelect: 'none' }}>
          {title}
        </MUITypography>
        <MUITypography
          variant="body2"
          sx={{
            borderRadius: 1,
            padding: '4px 8px',
            background: '#E7EBF2',
            display: 'inline',
            cursor: 'pointer',
            userSelect: 'none'
          }}
        >
          {id}
        </MUITypography>
      </MUIStack>

      {isOpen && !pageIsInEditMode && valuesLoaded && allowEditCustomData ? (
        <MUITooltip title={`Edit this form`} placement="top" arrow>
          <MUIIconButton onClick={toggleEditMode} sx={{ height: '48px', width: '48px' }}>
            <EditIcon sx={{ height: '20px', width: '22px' }} />
          </MUIIconButton>
        </MUITooltip>
      ) : null}

      {isOpen && pageIsInEditMode && valuesLoaded && allowEditCustomData ? (
        <CustomDataSaveButtons onSave={onSave} onCancel={onCancel} />
      ) : null}
    </MUIStack>
  )
}

CustomDataPageHeading.propTypes = {
  title: PropTypes.string,
  id: PropTypes.any,
  toggleEditMode: PropTypes.func,
  onToggleOpen: PropTypes.func,
  isOpen: PropTypes.bool,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  pageIsInEditMode: PropTypes.bool,
  valuesLoaded: PropTypes.bool
}
